import { state } from "../state.js";
import { renderHead, renderRows } from "../dom/table.js";
import {
  createEventCommon,
  setEventCommon,
  createFastestLapSessionData,
  setFastestLapSession,
  createRankingCommon,
} from "./shared/raceLike.js";
import { buildLapRankingColumns } from "./shared/rankingColumns.js";

function columnsFor(tableEntry) {
  return buildLapRankingColumns({
    multiClass: tableEntry.Classes.length > 1,
    includeAfterLeader: false,
    includeTotalTime: false,
  });
}

function createRankingHead() {
  for (const tableEntry of state.tableIdentifires) {
    const table = document.getElementById(tableEntry.tableId);
    renderHead(table, columnsFor(tableEntry));
  }
}

function updateRanking(data) {
  for (const tableEntry of state.tableIdentifires) {
    const table = document.getElementById(tableEntry.tableId);
    const ranking = data[tableEntry.Ranking].filter((row) => tableEntry.Classes.includes(row.Class));
    renderRows(table, columnsFor(tableEntry), ranking, "STN");
  }
}

export const trainingHandlers = {
  createEvent: createEventCommon,
  setEvent: setEventCommon,
  createSessionData: createFastestLapSessionData,
  setSessionData: setFastestLapSession,
  createRanking: createRankingCommon,
  createRankingHead,
  updateRanking,
};
